<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<div class="full flex" style="flex-direction: column;align-items: center;justify-content: center;">
					<div style="color: red;font-size: 20px;">请将编码记录到凭证上</div>
					<div style="font-size: 100px;font-weight: bolder;">{{vouchercode}}</div>
				</div>
			</template>
			<template #footer>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			vouchercode: {
				default: () => {
					return '0001'
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '凭证编码',
				modal_width: 500,
				modal_height: 500,
				invoicefile:[]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			// modal_init(){
			// 	this.invoicefile = this.row.invoicefile?JSON.parse(JSON.stringify(this.row.invoicefile)):[]
				
			// },
			submit() {
				this.modal_cancel()
			},
			reset() {
				
			}
		},
		components: {
			
		}
	}
</script>